var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79987 4H18.3999C19.2799 4 19.9999 4.72 19.9999 5.6V15.2C19.9999 16.08 19.2799 16.8 18.3999 16.8H8.79987C7.91987 16.8 7.19987 16.08 7.19987 15.2V5.6C7.19987 4.72 7.91987 4 8.79987 4ZM4 7.20003H5.6V18.4H16.8V20H5.6C4.72 20 4 19.28 4 18.4V7.20003ZM18.4001 15.1999H8.80013V5.59993H18.4001V15.1999ZM12 14V6.79997L16.8 10.4L12 14Z",
    fill: "#2B323B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.75d1aa2b3e1e0438e19e4a5e53436c12.svg";
export { ForwardRef as ReactComponent };